import React, { useState, useEffect } from "react";
import analytics from "web/script/analytics/analytics";
import CookieSettings, {
    CookieSettingsProps,
} from "web/react/components/cookie-settings/cookie-settings";
import withReduxProvider from "web/react/redux-provider";
import { ReduxStoreState } from "web/redux/store";
import { useDispatch, useSelector as useReduxSelector } from "react-redux";
import { closeOverlay } from "web/redux/ducks/cookie-settings";

interface CookieSettingsContainerProps {
    isOpen?: boolean;
    onModalClose?: () => void;
}

function extractState(state: ReduxStoreState): boolean {
    return state.cookieSettingsReducer.overlayIsOpen;
}

function CookieSettingsContainer({
    isOpen,
    onModalClose,
}: CookieSettingsContainerProps): JSX.Element {
    const dispatch = useDispatch();
    const [defaultIsOpen, setDefaultIsOpen] = useState(false);
    const settingsOverlayIsOpen = useReduxSelector(extractState);

    useEffect(() => {
        setDefaultIsOpen(settingsOverlayIsOpen);
    }, [settingsOverlayIsOpen]);

    function defaultOnClose(): void {
        dispatch(closeOverlay());
        setDefaultIsOpen(false);
    }

    let eventLabel;
    let cookieSettingsProps: CookieSettingsProps;
    if (typeof isOpen === "boolean" && onModalClose) {
        eventLabel = "banner";

        cookieSettingsProps = {
            isOpen: isOpen,
            onModalClose: onModalClose,
        };
    } else {
        eventLabel = "footer";

        cookieSettingsProps = {
            isOpen: defaultIsOpen,
            onModalClose: defaultOnClose,
        };
    }

    useEffect(() => {
        if (cookieSettingsProps.isOpen) {
            analytics.event("cookie_settings", "shown", eventLabel);
        }
    }, [cookieSettingsProps.isOpen, eventLabel]);

    return <CookieSettings {...cookieSettingsProps} />;
}

export default withReduxProvider(CookieSettingsContainer);
